var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("가상계좌")]), _c('div', {
    staticClass: "page-text grey--text text--darken-1 mt-1"
  }, [_vm._v("나누리 캐시 교환권 구매에 사용될 가상계좌를 설정하실 수 있습니다.")])]), _c('v-divider', {
    staticClass: "d-md-none"
  }), _vm.vaccount._id ? [_c('mypage-vaccount-view', _vm._b({}, 'mypage-vaccount-view', {
    vaccount: _vm.vaccount
  }, false))] : [_c('mypage-vaccount-none', _vm._g({}, {
    post: _vm.post
  }))]], 2), _c('common-loader', _vm._b({}, 'common-loader', {
    loading: _vm.loading
  }, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }